import * as React from "react";
import { IconProps } from "../types";

const UsersFillIcon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", ...props }, forwardedRef) => {
    return (
      <svg
        width="18"
        height="18"
        fill="none"
        viewBox="0 0 18 18"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={forwardedRef}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.4247 12.431C2.45321 10.3968 4.56094 8.99951 7 8.99951C9.43928 8.99951 11.5468 10.398 12.5752 12.431C13.1949 13.6563 12.5204 15.0968 11.2863 15.5259C10.1931 15.9055 8.732 16.2505 7 16.2505C5.268 16.2505 3.80712 15.9056 2.71397 15.526C1.47801 15.0968 0.805372 13.6559 1.4247 12.431Z"
          fill={color}
        />
        <path
          d="M14.175 14.3918C14.4107 13.5586 14.3575 12.6314 13.9137 11.7539C13.178 10.2994 11.9948 9.10509 10.5425 8.35604C11.1507 8.12567 11.8104 7.99951 12.5 7.99951C14.6128 7.99951 16.4448 9.18375 17.3755 10.9212C17.4298 11.0228 17.482 11.1262 17.5225 11.232C17.9109 12.2456 17.4302 13.4485 16.3473 13.8341C15.872 14.0032 15.3136 14.1672 14.6817 14.2901L14.5855 14.3111C14.4491 14.341 14.3122 14.3679 14.175 14.3918Z"
          fill={color}
        />
        <path
          d="M7 7.25049C8.519 7.25049 9.75 6.01949 9.75 4.50049C9.75 2.98149 8.519 1.75049 7 1.75049C5.481 1.75049 4.25 2.98149 4.25 4.50049C4.25 6.01949 5.481 7.25049 7 7.25049Z"
          fill={color}
        />
        <path
          d="M11.0677 5.736C11.1862 5.34503 11.25 4.93021 11.25 4.50049C11.25 3.79811 11.0797 3.13556 10.778 2.55189C11.1907 2.0618 11.8089 1.75049 12.5 1.75049C13.743 1.75049 14.75 2.75749 14.75 4.00049C14.75 5.24349 13.743 6.25049 12.5 6.25049C11.9557 6.25049 11.4567 6.05742 11.0677 5.736Z"
          fill={color}
        />
      </svg>
    );
  },
);

export default UsersFillIcon;
